
import styles from "./ReceiptsOrder.module.scss";
import { useEffect, useState } from 'react'
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import numberToWordsRu from 'number-to-words-ru';

import userInfo from "utils/userInfo";

const ReceiptsOrder = ({ setOpenModalOrder, item }) => {
    const componentRef = useRef();
    const user = userInfo();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    function numberToSomText(amount) {
        const [som, tiyin] = amount.toString().split(".");

        let somText = numberToWordsRu.convert(Number(som), {
            showCurrency: false,
            currency: false,
        });

        // Убираем слова рублей/копеек
        somText = somText.replace(/руб(ль|ля|лей)?/gi, "").replace(/коп(ейка|ейки|еек)?/gi, "");

        // Убираем все цифры (например "00") в любом месте строки
        somText = somText.replace(/\b\d+\b/g, "");

        // Убираем лишние пробелы после удаления цифр
        somText = somText.replace(/\s{2,}/g, " ").trim();

        // Заглавная буква
        somText = somText.charAt(0).toUpperCase() + somText.slice(1);

        somText = `${somText} сом`;

        const tiyinText = (tiyin ? tiyin.padEnd(2, "0") : "00");

        return `${somText} ${tiyinText} тыйын`;
    }




    return (

        <div className={styles.div_print_selection}  >
            <button className={styles.btn_print} onClick={handlePrint}>Печать 🖨️ </button>
              <Button
                onClick={() => setOpenModalOrder(false)}
                className={styles.close_btn_sub}
            >
                {" "}
                Закрыть
            </Button>
            <div ref={componentRef} className={styles.formWrapper}>
                <div className={styles.docInfo} style={{width:"100%", justifyContent:"end"}}>
                    Унифицированная форма КО-1 Утверждена постановлением <br></br>
                    Нацстаткомитета Кыргызской Ресспублики от 07.04.2003 №4
                </div>
                <div className={styles.docInfo_header}>

                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th className={styles.table_th}></th>
                                <th>Код</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={styles.table_th}>Форма по ГКУД</td>
                                <td>0310001</td>
                            </tr>
                            <tr>
                                <td className={styles.table_th}>по ОКПО</td>
                                <td>05965896</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h2 className={styles.title}>Приходный кассовый ордер</h2>
                <div className={styles.docInfo_title}>
                    <div>
                        <h3 className={styles.title}>БКЧУ</h3>
                        <h4 className={styles.title}>организация</h4>
                    </div>
                    <div>
                        <h4 className={styles.title}>_____________________________</h4>
                        <h4 className={styles.title}>подразделение</h4>
                    </div>
                </div>
                <div className={styles.docInfo}>
                    <div>Номер документа: <strong>{item.order}</strong></div>
                    <div>Дата составления: <strong>{item.date_сreate}</strong></div>
                </div>

                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Дебет</th>
                            <th>Кредит</th>
                            <th>Сумма, сом</th>
                           <th>Код целевого назначения</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1110</td>
                            <td className={styles.table_in_td}>
                                <table className={styles.table_in}>
                                    <thead>
                                        <tr>
                                            <td>Код структурного подразделения</td>
                                            <td>Корректируемый счет-субсчет</td>
                                            <td>Код начислительного учета</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td ></td>
                                            <td>{item.check}</td>
                                            <td></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </td>
                            <td>{item.amount}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>

                <div className={styles.details}>
                    <div>Принято от: <strong>{item.source}</strong></div>
                    <div>Основание: <em>{item.check_base}</em></div>
                    <div>Сумма: <strong>{numberToSomText(item.amount)}</strong></div>
                </div>

                <div className={styles.signatures}>
                    <div className={styles.sigRow}>
                        <div>
                            Главный бухгалтер:<br />
                            <span className={styles.sigLine}></span><br />
                            <em>{user.surName} {user.firstName}</em>
                        </div>
                        <div>
                            Кассир:<br />
                            <span className={styles.sigLine}></span><br />
                            <em>{user.surName} {user.firstName}</em>
                        </div>
                    </div>
                </div>

                <hr className={styles.divider} />

                <h2 className={styles.title}>Квитанция</h2>
                <div className={styles.docInfo}>
                    <div>№ к/о: <strong>{item.order}</strong> от <strong>{item.date_сreate}</strong></div>
                    <div>Принят от: <strong>{item.source}</strong></div>
                </div>

                <div className={styles.details}>
                    <div>Основание: <em>{item.check_base}</em></div>
                    <div>Сумма: <strong>{item.amount}</strong></div>
                    <div>Прописью: <strong>{numberToSomText(item.amount)}</strong></div>
                </div>

                <div className={styles.signatures}>
                    <div className={styles.sigRow}>
                        <div>
                            М.П. (штамп) <br />
                            <span className={styles.sigLine}></span><br />
                            <em>Главный бухгалтер {user.surName} {user.firstName}</em>
                        </div>
                        <div>
                            Кассир:<br />
                            <span className={styles.sigLine}></span><br />
                            <em>{user.surName} {user.firstName}</em>
                        </div>
                    </div>
                </div>
            </div >

          

        </div>


    );
};

export default ReceiptsOrder;
